import React from "react";
import ContactUs from "../../../components/contact-us/contact-us";
import "./styles.scss";

const ContactUsView = () => {
  return (
    <div className="ContactUs-page contact-view">
      <div className="ContactUs-content">
        <ContactUs />
      </div>
    </div>
  );
};

export default ContactUsView;
